import { ReactNode } from "react";

interface ModalProps {
  is_open: boolean;
  on_close: () => void;
  children: ReactNode;
}

export default function Modal({ is_open, on_close, children }: ModalProps) {
  if (!is_open) return null;

  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center bg-black/50"
      onClick={on_close}
    >
      <div
        className="bg-surface rounded-[4px] p-[24px] max-w-[400px] w-[90%] border-[1px] border-lines"
        onClick={(e) => e.stopPropagation()}
      >
        {children}
      </div>
    </div>
  );
}
